import { RefObject, useEffect } from 'react';

import { IModal } from '../types/modal';
import { isOfType } from '../utils/typeGuard';
import useModal from './useModal';

interface UseBackdropOptions {
  isScroll?: boolean;
  buttonClass?: string;
  onBackdropClick?: (target: HTMLElement) => void;
  onClose?: () => void;
}

function useBackdrop(
  props: IModal,
  ref: RefObject<HTMLDivElement>,
  options: UseBackdropOptions = {}
) {
  const { isScroll = false, buttonClass, onBackdropClick, onClose } = options;
  const { toggleModal } = useModal();
  const { id, type } = props;

  useEffect(() => {
    const scrollContainers = document.querySelectorAll(
      '.container, .simplebar-content-wrapper'
    );

    const handleClick = ({ target }: MouseEvent) => {
      if (
        isOfType<HTMLElement>(target, 'nodeName') &&
        !ref.current?.contains(target) &&
        id !== 'pdfConverting'
      ) {
        onBackdropClick?.(target);
        if (
          (buttonClass && !target?.closest(`.${buttonClass}`)) ||
          !buttonClass
        ) {
          onClose?.();
          toggleModal(props);
        }
      }
    };

    const handleScroll = ({ target }: Event) => {
      if (
        isOfType<HTMLElement>(target, 'nodeName') &&
        !target.querySelector('.content_wrap') &&
        !target.closest('.alert') &&
        type !== 'alert' &&
        type !== 'component'
      ) {
        onClose?.();
        toggleModal(props);
      }
    };

    window.addEventListener('mousedown', handleClick);
    scrollContainers.forEach((el) => {
      el.addEventListener('scroll', handleScroll);
    });

    return () => {
      window.removeEventListener('mousedown', handleClick);
      scrollContainers.forEach((el) => {
        el.removeEventListener('scroll', handleScroll);
      });
    };
  }, [ref, onBackdropClick, onClose, id, type, buttonClass, toggleModal]);

  if (!isScroll) {
    useEffect(() => {
      const body = document.body;
      const overflow = body.style.overflow;

      body.style.overflow = 'hidden';

      return () => {
        body.style.overflow = overflow;
      };
    }, []);
  }
}

export default useBackdrop;
